import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actionButtonAPICallRequest, resetActionButtonAPICall } from '../../views/dashboard/store/actionButtonApiCall.slice';
import useLegacySupport from '../hooks/useLegacySupported';
import { saveAs } from 'file-saver';
import Modal from '../atoms/modal';

interface DownloadPDFButtonProps {
  label: string;
  data?: any;
  fileName?: string;
  onClick?: (res:any) => void;
  payload?: any;
  disabled?: boolean;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
}

const DownloadPDFButton: React.FC<DownloadPDFButtonProps> = ({
  label,
  data,
  fileName,
  onClick,
  payload,
  disabled = false,
  className = '',
  type = 'button'
}) => {
  const token = useLegacySupport();
  const dispatch = useDispatch();

  const [showModal, setShowModal] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState<string | null>(null);

  const actionButtonData = useSelector((state: any) => state.actionButtonData);
  
  useEffect(() => {
    if (actionButtonData.isSuccess && actionButtonData.data.data !== null) {
      try {
        const disposition = actionButtonData.data.headers['content-disposition'];
        let fName = fileName || 'download.pdf';
        if (disposition && disposition.includes('filename=')) {
          fName = disposition.split('; ')[1].replace('filename=', '') || fName;
        }
        saveAs(new Blob([actionButtonData.data.data], { type: 'application/pdf' }), fName);
        setShowModal(false);
        setErrorMsg(null);
      } catch (err: any) {
        setErrorMsg('Failed to download PDF. Please try again.');
      }
      dispatch(resetActionButtonAPICall());
    } else if (actionButtonData.isError) {
      setErrorMsg(actionButtonData.error.detail || actionButtonData.error.message || 'An error occurred cannot download PDF.');
      dispatch(resetActionButtonAPICall());
    }
  }, [actionButtonData, onClick, dispatch, fileName]);


  const handleClick = async () => {
    setShowModal(true);
  }

  const handleClickStart = async () => {
    setErrorMsg(null);
    // Execute custom onClick if provided
    if (onClick) {
      onClick(payload);
    }
    // Dispatch Redux action if apiConfig is provided
    if (data) {
      const params:any = {}
      data.apiParameters.map((res:any) => {
        params[res] = payload[res]
        return null;
      });
      const actionPayload:any = {
        token: token.token,
        url: data.apiEndpoint.replace("/api", ""),
        param: {
          ...params
        }
      }
      dispatch(actionButtonAPICallRequest(actionPayload));
    }
  };

  const isButtonDisabled = disabled || actionButtonData.isFetching;

  return (
    <>
    <Modal title="Download Confirmation" show={showModal} onClose={() => setShowModal(false)}>
      <div>
        By exporting this PDF, you will be downloading this information from OneView. If you do not need to download this information, please close this window. If you need to download this information, please click OK.
      </div>
      {errorMsg && (
        <div style={{ color: '#d32f2f', marginTop: '12px' }}>
          Error: {errorMsg}
        </div>
      )}
      <div style={{marginTop: '20px', textAlign: 'right'}}>
        <button className="btn-action btn-cancel" style={{marginRight: '12px'}} onClick={() => setShowModal(false)}>Cancel</button>
        <button className="btn-action btn-ok" onClick={handleClickStart}>OK</button>
      </div>
    </Modal>
    <button
      type={type}
      onClick={handleClick}
      disabled={isButtonDisabled}
      className={`action-button ${className} ${isButtonDisabled ? 'disabled' : ''}`}
    >
      {(actionButtonData.isFetching) ? 'Downloading...' : label}
    </button>
    </>
  );
};

export default DownloadPDFButton;